module.exports = __webpack_public_path__ + "static/media/vida_ativa.2b252b0d.webp";